import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { deserialise } from "kitsu-core";

import { PortalAxiosError } from "../types";
import { extendAxiosError } from "../utils/errors";

interface ServerOptions {
  appAgent?: string;
  axiosRequestConfig?: AxiosRequestConfig;
  debug?: boolean;
  getAuthorization?: () => Promise<string>;
}

const createServer = (options: ServerOptions) => {
  const server = axios.create(options.axiosRequestConfig);

  server.interceptors.request.use(async (config) => {
    if (options.appAgent) {
      config.headers = Object.assign(
        {
          "App-Agent": options.appAgent,
        },
        config.headers
      );
    }

    if (typeof options.getAuthorization === "function") {
      const authorization = await options.getAuthorization();

      if (authorization) {
        config.headers = Object.assign(
          {
            Authorization: authorization,
          },
          config.headers
        );
      }
    }

    return config;
  });

  server.interceptors.response.use(
    (axiosResponse: AxiosResponse) => {
      if (options.debug && axiosResponse.request) {
        console.log(
          `${axiosResponse.request._method}: ${axiosResponse.request._url}`
        );
      }

      return deserialise(axiosResponse.data);
    },
    (axiosError: PortalAxiosError) => {
      throw extendAxiosError(axiosError);
    }
  );

  return server;
};

export default createServer;
